import FloatingBanner from './FloatingBanner.component';

export default FloatingBanner;